/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';

import { IAlphabetListViewProps } from './alphabet-list';

export default (props: IAlphabetListViewProps) => {
    return ( 
        <Module {...props.alphapetContainer} >
            {props.letterItems}
        </Module>
    );
};
